import _ from 'lodash';
import { useEffect } from 'react';

export const useInitiateEditor = (editor: any | null, text: string | undefined) => {
  useEffect(() => {
    if (!_.isNil(editor) && !_.isNil(text)) {
      editor.setText(text);
    }
  }, [editor, text]);
};
